var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('WalletBody',{attrs:{"user":_vm.user,"loading":_vm.loading,"isTransactions":_vm.isTransactions,"transactions":_vm.transactions,"usdValue":_vm.usdValue,"isUsd":_vm.isUsd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }